var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fixed-btn",class:{ 'no-header': !_vm.headConfig.showHead },on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }